module.exports = __webpack_public_path__ + "static/media/alerta-documentacion-chofer-verde.89dada25.svg";